import { GpChildProduct } from '@/app/editor/iframe/atom/module/GpChildProduct';
import type { AtomModel, FormControlSetting, Font } from '@/app/editor/iframe/atom/Atom.model';
import { convertImgUrlToImageUrl } from '@/app/utils/convertImgUrlToImageUrl';
declare let Liquid: any;
// import { isBlockedScript } from "@/app/utils/helpers";
const FormControlSettings: Array<FormControlSetting> = [
  {
    name: 'badgePosition',
    type: 'badge:position',
    targetSelector: '.gf_product-badge-anchor',
    default_value: '',
    mode: 'responsive-mode',
    refreshType: 'all',
    property: '',
    selfSelector: '-1,1',
  },
  {
    name: 'badgePositionTop',
    type: 'badge:positionDirection',
    targetSelector: '.gf_product-badge-anchor',
    default_value: '5px',
    mode: 'responsive-mode',
    property: 'top',
    selfSelector: '-1,1',
  },
  {
    name: 'badgePositionBottom',
    type: 'badge:positionDirection',
    targetSelector: '.gf_product-badge-anchor',
    default_value: '5px',
    mode: 'responsive-mode',
    property: 'bottom',
    selfSelector: '1,1',
  },
  {
    name: 'badgePositionRight',
    type: 'badge:positionDirection',
    targetSelector: '.gf_product-badge-anchor',
    default_value: '5px',
    mode: 'responsive-mode',
    property: 'right',
    selfSelector: '1,1',
  },
  {
    name: 'badgePositionLeft',
    type: 'badge:positionDirection',
    targetSelector: '.gf_product-badge-anchor',
    default_value: '5px',
    mode: 'responsive-mode',
    property: 'left',
    selfSelector: '1,1',
  },
  {
    name: 'badgeRotateFrame',
    type: 'badge:rotateframe',
    targetSelector: '.gf_product-badge-anchor',
    default_value: '5px',
    mode: 'responsive-mode',
    property: '',
    selfSelector: '1,1',
  },
  {
    name: 'badgeRotateText',
    type: 'badge:rotatetext',
    targetSelector: '.gf_product-badge-anchor span',
    default_value: '5px',
    mode: 'responsive-mode',
    property: '',
    selfSelector: '-1,1',
  },
  {
    name: 'displayType',
    type: 'badge:displaytype',
    targetSelector: '.gf_product-badge-anchor',
    default_value: '',
    mode: 'responsive-mode',
    property: '',
    selfSelector: '-1,1',
  },
  {
    name: 'percentagePrice',
    type: 'badge:displaytype',
    targetSelector: '.gf_product-badge-anchor',
    default_value: '',
    mode: 'responsive-mode',
    property: '',
    selfSelector: '-1,1',
  },
  {
    name: 'badgeColor',
    type: 'css',
    targetSelector: '.gf_badge-text-wrap',
    default_value: '',
    mode: 'responsive-mode',
    property: 'color',
    selfSelector: '-1,1',
  },
  {
    name: 'badgeFontSize',
    type: 'css',
    targetSelector: '.gf_badge-text-wrap',
    default_value: '5px',
    mode: 'responsive-mode',
    property: 'font-size',
    selfSelector: '-1,1',
  },
  {
    name: 'badgeTextLineHeight',
    type: 'css',
    targetSelector: '.gf_badge-text-wrap',
    default_value: '2em',
    mode: 'responsive-mode',
    property: 'line-height',
    selfSelector: '-1,1',
  },
  {
    name: 'badgeFont',
    type: 'css',
    targetSelector: '.gf_badge-text-wrap',
    default_value: '',
    mode: 'responsive-mode',
    property: 'font-family',
    selfSelector: '-1,1',
  },
  {
    name: 'firstBackgound',
    type: 'badge:gradient',
    targetSelector: '.gf_badge-text-wrap',
    default_value: '',
    mode: 'responsive-mode',
    property: '',
    selfSelector: '-1,1',
  },
  {
    name: 'secondBackgound',
    type: 'badge:gradient',
    targetSelector: '.gf_badge-text-wrap',
    default_value: '',
    mode: 'responsive-mode',
    property: '',
    selfSelector: '-1,1',
  },
  {
    name: 'badgeWidth',
    type: 'css',
    targetSelector: '.gf_product-badge-anchor',
    default_value: '60px',
    mode: 'responsive-mode',
    property: 'width',
    selfSelector: '-1,1',
  },
  {
    name: 'badgeHeight',
    type: 'css',
    targetSelector: '.gf_product-badge-anchor',
    default_value: '60px',
    mode: 'responsive-mode',
    property: 'height',
    selfSelector: '-1,1',
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];

/**
 * Product Price Atom Module
 */
export class GpProductImage extends GpChildProduct {
  public $el: JQuery;
  /**
   * Thông tin riêng của Atom
   * @returns object watch
   */
  getDataAtom(): AtomModel {
    const data: AtomModel = {
      type: this.getType(),
      id: this.getId(),
      nodeId: this.getIdNode(),
      name: this.getLabel(),
      slug: this.getSlug(),
      groupName: this.getGroupName(),
      settings: this.getSettings(),
      formControlSettings: FormControlSettings,
      data: this.getDataChilds(),
      html: this.getTemplate(),
      class: this.getTargetClassSelector(),
      style: this.getStyle(),
      script: this.getScript(),
      libs: this.getLibs(),
      fonts: [] as Array<Font>,
      version: 1,
    };
    return data;
  }
  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || '(P) Image';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'p-image';
  }
  /**
   * get Data from html attr
   * @returns Group Name
   */
  getGroupName(): string {
    return this.$el.attr('data-groupname') || 'Module';
  }
  /**
   * cloneAtom
   * @param $atomClone :jQuery
   * @param templateTmp :string
   * @returns $atomClone
   */
  cloneAtom($atomClone: JQuery, templateTmp: string): JQuery {
    const matchedString = new RegExp('product.options', 'g');
    templateTmp = templateTmp.replace(matchedString, 'product.options_with_values');
    // img_url always returns the 100x100 variant for avif images
    templateTmp = convertImgUrlToImageUrl(templateTmp);
    return $atomClone.html(templateTmp);
  }
}
